const ESCHeader = () => {
  return (
    <div className="ESCHeader">
      <div className="ESCLogoType">
        <a href="https://esc.rutgers.edu/">
          <img
            src="images/esc-logo.png"
            title="Rutgers Equine Science Center"
            alt="Rutgers Equine Science Center Logo"
          />
        </a>
      </div>

      <div className="ESCHeaderLinks">
        <div className="ESCLibrary">
          <a href="https://esc.rutgers.edu/resources/library/">Library</a>
        </div>
        <div className="ESCKidsCorner">
          <a href="https://esc.rutgers.edu/kids-corner/">Kid's Corner</a>
        </div>
        <ul className="ESCSocial">
          <div className="ESCSocIcon">
            <a
              href="https://www.facebook.com/RutgersESC/"
              target="_blank"
              rel="noreferrer"
            >
              <span className="icon-facebook"></span>
            </a>
          </div>
          <div className="ESCSocIcon">
            <a
              href="https://twitter.com/RutgersESC"
              target="_blank"
              rel="noreferrer"
            >
              <span className="icon-twitter"></span>
            </a>
          </div>
          <div className="ESCSocIcon">
            <a
              href="https://www.youtube.com/channel/UCKZUbdHAbpJrAQXUNqaCdIw"
              target="_blank"
              rel="noreferrer"
            >
              <span className="icon-youtube"></span>
            </a>
          </div>
        </ul>
        <a className="ESCDonate" href="https://esc.rutgers.edu/donate">
          Donate
        </a>
        <div className="ESCSearch">
          <a href="https://search.rutgers.edu" target="_blank" rel="noreferrer">
            <span className="icon-search"></span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default ESCHeader
